import React, { useMemo, useState,useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortUp, faSortDown } from "@fortawesome/free-solid-svg-icons";
import ExportCSVButton from '../utils/ExportCSVButton';
import axios from "axios";
import { useAuth } from "../contexts/AuthContext";
import Swal from 'sweetalert2';
import CreatableSelect from 'react-select/creatable';
import MiniDashboardGuiaStatus from './MiniDashboardGuiaStatus';

const General = ({
  allItems, // Todo sin filtrar
  items,
  filters,
  setFilters,
  requestSort,
  sortConfig,
  renderPagination,
  renderSelectFilters

}) => {
  const { currentUser } = useAuth();
  const [observacionesMap, setObservacionesMap] = useState({});
  const [statusGuiaMap, setStatusGuiaMap] = useState({});
  const [userOptions, setUserOptions] = useState([]);
  const [usuarioMap, setUsuarioMap] = useState({});
  const [obsOptions, setObsOptions] = useState([]);


  const statusOptions = [
    { label: "Pendiente", value: "Pendiente" },
    { label: "Liberada", value: "Liberada" },
    { label: "Subdivision y Abandono", value: "Subdivision y Abandono" },
    { label: "Abandono", value: "Abandono" },
    { label: "En espera de Complemento", value: "En espera de Complemento" },
  ];

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/bookings/users/list`);
        const fetchedOptions = res.data.map(user => ({
          label: user.usuario,
          value: user.usuario,
        }));
        setUserOptions(fetchedOptions);

        const usuarioSet = new Set(fetchedOptions.map(u => u.value));

        const extras = Object.values(usuarioMap)
          .filter(val => !usuarioSet.has(val))
          .map(val => ({ label: val, value: val }));

        if (extras.length > 0) {
          setUserOptions(prev => [...prev, ...extras]);
        }
      } catch (error) {
        console.error("Error cargando usuarios.", error);
      }
    };

    fetchUsers();
  }, []);


  useEffect(() => {
    const fetchObservaciones = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/bookings/observations/list`);
        console.log(res);
        const fetchedOptions = res.data.map(observacion => ({
          label: observacion.label,
          value: observacion.value,
        }));
        setObsOptions(fetchedOptions);
        const ObsSet = new Set(fetchedOptions.map(u => u.value));
        const extras = Object.values(observacionesMap)
          .filter(val => !ObsSet.has(val))
          .map(val => ({ label: val, value: val }));
        if (extras.length > 0) {
          setObsOptions(prev => [...prev, ...extras]);
        }
      } catch (error) {
        console.error("Error cargando observaciones.", error);
      }
    };

    fetchObservaciones();
  }, []);


  const updateUsuario = async (bookingId, newUsuario, bookingCode) => {
    try {
      const user = currentUser?.profile?.email;

        // Actualiza en frontend
        setUsuarioMap(prev => ({
          ...prev,
          [bookingId]: newUsuario
        }));

      // Actualiza en backend
        await axios.post(`${process.env.REACT_APP_BACKEND_API_URL}/api/bookings/${bookingId}/user`, {
          userHella: newUsuario,
          user,
        });

      Swal.fire({
        position: 'top-end',
        icon: 'success',
        html: `<div style="font-weight: bold; font-size: 16px;">${bookingCode}</div>
        <div style="font-size: 12px; margin-top: 4px;">Usuario actualizado</div>`,
        showConfirmButton: false,
        timer: 1500,
        toast: true,
      });
    } catch (error) {
      console.error("Error actualizando usuario:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo actualizar el usuario',
      });
    }
  };

  const createNewUsuario = async (inputValue, itemId, bookingCode) => {
    try {
      const user = currentUser?.profile?.email;
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_API_URL}/api/bookings/users/create`, {
        userHella: inputValue,
        user: user
      });

      const newOption = { label: res.data.usuario, value: res.data.usuario };
      setUserOptions(prev => [...prev, newOption]);
      await updateUsuario(itemId, newOption.value, bookingCode);
      setUsuarioMap(prev => ({
        ...prev,
        [itemId]: newOption.value,
      }));

    } catch (err) {
      console.error("Error creando nuevo usuario", err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo crear el nuevo usuario',
      });
    }
  };

  const handleObservacionChange = (index, newValue) => {
    setObservacionesMap(prev => ({
      ...prev,
      [index]: newValue,
    }));
  };

  // Campos relevantes para el reporte general basado en EBooking
  const keyMap = {

    "Booking Status": "bookingStatus",
    "Booking Code": "bookingCode",
    "Customer": "clienteRazonSocial",
    "BL Status": "statusGuia",
    "BL Master": "numeroBolMaster",
    "BL House": "bolHouse",
    "Usuario": "usuario",
    "Observaciones": "observaciones",
    "Planta": "planta",
    "Division": "division",
    "Aduana": "aduana",
    "Referencia": "referencia",
    "Pedimento": "pedimento",
    "Tipo Pedimento":"tipoPedimento",
    "Remesa": "remesaPedimento",
    "Fecha ETA": "fechaETA",
    "Fecha Arribo": "fechaArribo",
    "Fecha Modulación": "fechaModulacion",
  };

  const columnWidths = {
    "bookingStatus": "120px",
    "clienteRazonSocial": "400px",
    "planta": "200px",
    "referencia": "150px",
    "bookingCode": "200px",
    "pedimento": "150px",
    "numeroBolMaster": "150px",
    "fechaArribo": "120px",
    "fechaETA": "120px",
    "fechaModulacion": "120px",
    "carrier": "150px",
    "observaciones": "400px",
    "usuario": "300px",
  };

  const gridTemplateColumnsStyle = {
    display: "grid",
    gridTemplateColumns: Object.values(keyMap)
      .map((key) => columnWidths[key] || "150px")
      .join(" "),
  };

  const displayItems = useMemo(() => {
    return items;
  }, [items]);

  const csvData = items.length > 0
    ? items.map(item => {
      const row = {};
      Object.entries(keyMap).forEach(([header, key]) => {
        row[header] = item[key] ?? "";
      });
      return row;
    })
    : [Object.keys(keyMap).reduce((acc, header) => {
      acc[header] = ""; // Agrega encabezados aunque sin datos
      return acc;
    }, {})];

  // Función para obtener el color del estado // EBooking por status
  const getStatusColor = (bookingStatus) => {
    const statusColors = {
      "Pre-Alert": "bg-blue-200 text-blue-800",
      "Alert": "bg-yellow-100 text-yellow-800",
      "Revalidacion": "bg-red-100 text-red-800",
      "Previo": "bg-yellow-100 text-yellow-800",
      "Envio DODA": "bg-pink-100 text-pink-800",
      "Pagado": "bg-purple-100 text-purple-800",
      "Delivered": "bg-blue-100 text-blue-800",
      "Cancelado": "bg-red-100 text-red-800",
      default: "bg-orange-100 text-orange-800"
    };
    return statusColors[bookingStatus] || statusColors.default;
  };


  const saveObservaciones = async (bookingId, nuevaObservacion, bookingCode) => {
    try {
      const user = currentUser?.profile?.email;
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_API_URL}/api/bookings/${bookingId}/observations`,
        {
          observaciones: nuevaObservacion, 
          user: user
        }
      );
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        html: `<div style="font-weight: bold; font-size: 16px;">${bookingCode}</div>
          <div style="font-size: 12px; margin-top: 4px;">Observación actualizada</div>`,
        showConfirmButton: false,
        timer: 1500,
        toast: true,
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo actualizar la observación',
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCloseButton: true  
      });
    }
  };


  const updateStatus = async (bookingId, status, bookingCode) => {
    try {
      const user = currentUser?.profile?.email;
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_API_URL}/api/bookings/${bookingId}/awbstatus`,
        {
          estado: status,
          user: user
        }
      );
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        html: `<div style="font-weight: bold; font-size: 16px;">${bookingCode}</div>
          <div style="font-size: 12px; margin-top: 4px;">Estado actualizado</div>`,
        showConfirmButton: false,
        timer: 1500,
        toast: true,
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo actualizar la observación',
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCloseButton: true
      });
    }
  };

  return (
    <>
      {renderSelectFilters()}

      <MiniDashboardGuiaStatus items={allItems} statusOptions={statusOptions} />

      <div className="flex justify-between items-center mb-4">
        <div className="text-sm text-gray-600">
        </div>
        <ExportCSVButton data={csvData} filename="reporte_guias_general.csv" />
      </div>

      {renderPagination()}
      <div className="py-8">
        <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
          <div className="inline-block min-w-full shadow-lg rounded-lg overflow-hidden">
            <div
              className="bg-gray-200 px-6 py-3 grid items-center border-b border-gray-300 sticky top-0 z-10"
              style={{ ...gridTemplateColumnsStyle, minHeight: "48px" }}
            >
              {Object.keys(keyMap).map((header, index) => {
                const key = keyMap[header];
                let sortIcon =
                  sortConfig.key === key ? (
                    sortConfig.direction === "ascending" ? (
                      <FontAwesomeIcon icon={faSortUp} className="text-blue-600"
                      />
                    ) : (
                      <FontAwesomeIcon icon={faSortDown} className="text-blue-600"
                      />
                    )
                  ) : (
                    <FontAwesomeIcon icon={faSortUp} className="text-gray-400"
                    />
                  );
                return (
                  <div
                    key={index}
                    className={`text-xs font-semibold uppercase tracking-wider text-center py-2 cursor-pointer ${sortConfig.key === key ? "text-blue-600" : "text-gray-700"
                      } hover:text-blue-400`}
                    onClick={() => requestSort(key)}
                  >
                    {header} {sortIcon}
                  </div>
                );
              })}
            </div>

            <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
              {displayItems.map((item, index) => (
                <div
                  key={index}
                  className={`grid items-center text-center text-sm ${index % 2 === 0 ? "bg-white" : "bg-gray-50"
                    } hover:bg-gray-100`}
                  style={{ ...gridTemplateColumnsStyle, height: "auto" }}
                >
                  {Object.entries(keyMap).map(([header, key], colIndex) => {
                    const cellValue = item[key] || "";

                    // Si es la columna de estado, aplicamos color
                    if (key === 'bookingStatus') {
                      return (
                        <div
                          key={colIndex}
                          className="text-xs px-2 border-b border-gray-200 flex items-center justify-center"
                          style={{ height: '56px' }}
                        >
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(cellValue)}`}>
                            {cellValue}
                          </span>
                        </div>
                      );
                    }

                    //Si es el estado de la guia , aplicamos validacion para seleccionar estado por combo
                    if (key === 'usuario') {
                      return (
                        <div key={colIndex} className="text-xs px-2 border-b border-gray-200 flex items-center" style={{ height: '56px' }}>
                          <CreatableSelect
                            placeholder="Seleccionar o crear"
                            options={userOptions}
                            value={userOptions.find(opt => opt.value === (usuarioMap[item.id] ?? item.usuario)) || null}
                            onChange={async (selected) => {
                              if (selected) {
                                await updateUsuario(item.id, selected.value, item.bookingCode);
                                setUsuarioMap(prev => ({
                                  ...prev,
                                  [item.id]: selected.value,
                                }));
                              }
                            }}
                            onCreateOption={(inputValue) => createNewUsuario(inputValue, item.id, item.bookingCode)}
                            isClearable
                            isSearchable
                            className="w-full text-xs"
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: '24px',
                                height: '24px',
                                fontSize: '12px',
                              }),
                              indicatorsContainer: (base) => ({
                                ...base,
                                height: '24px',
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                padding: '0 4px',
                              }),
                            }}
                          />
                        </div>
                      );
                    }


                    //Si es el estado de la guia , aplicamos validacion para seleccionar estado por combo
                    if (key === 'statusGuia') {
                      const options = statusOptions; // obtener catalogo de estados
                      const currentValue = statusGuiaMap[item.id] ?? cellValue; // valor actual del campo statusGuia

                      const isDisabled =
                       currentValue === 'Liberada' && (
                          (item.tipoPedimento === 'C' && item.bookingStatus === 'Pagado') ||
                          (item.tipoPedimento === 'I' && item.bookingStatus === 'Delivered')
                        );

                      return (
                        <div key={colIndex} className="text-xs px-2 border-b border-gray-200 flex items-center" style={{ height: '56px' }}>
                          <select
                            className="border rounded text-xs px-1 h-[24px] w-full bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
                            value={statusGuiaMap[item.id] ?? cellValue}
                            onChange={async (e) => {
                              const newValue = e.target.value;
                              if (key === 'statusGuia' && !isDisabled) {
                                await updateStatus(item.id, newValue, item.bookingCode);
                                setStatusGuiaMap(prev => ({
                                  ...prev,
                                  [item.id]: newValue,
                                }));
                              }
                            }}
                            disabled={isDisabled}
                            style={{ padding: '0 4px', lineHeight: '24px' }}
                          >
                            <option value="">-- Seleccionar --</option>
                            {options.map((option, idx) => (
                              <option key={idx} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      );
                    }

                    //Cambia a carga de catalogo de Mongo DB
                    if (key === 'observaciones') {
                      const options = obsOptions ; // obtener catalogo de estados
                      return (
                        <div key={colIndex} className="text-xs px-2 border-b border-gray-200 flex items-center" style={{ height: '56px' }}>
                          <select
                            className="border rounded text-xs px-1 h-[24px] w-full bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
                            value={observacionesMap[item.id] ?? cellValue}
                            onChange={async (e) => {
                              const newValue = e.target.value;
                                await saveObservaciones(item.id, newValue, item.bookingCode);
                                setObservacionesMap(prev => ({
                                  ...prev,
                                  [item.id]: newValue,
                                }));
                              
                            }}
                            style={{ padding: '0 4px', lineHeight: '24px' }}
                          >
                            <option value="">-- Seleccionar --</option>
                            {options.map((option, idx) => (
                              <option key={idx} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>);
                    }

                    return (
                      <div
                        key={colIndex}
                        className="text-xs px-2 border-b border-gray-200 flex items-center justify-center"
                        style={{ height: '56px' }}
                      >
                        {cellValue}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {renderPagination()}
    </>
  );
};

export default General;